<template>

    <input-autocomplete
        v-bind="getInputProps({
            onSelect: onAutocompleteSelect,
            onKeyDown: onInputWrite,
            onBlur: onInputBlur,
        })"

        v-model="inputValue"

        ref="input"
    >
        <template #beforeInput>
            <template v-if="!hideTags" v-for="tag in tags">
                <div class="col-auto p-1">
                    <div class="badge badge-pill badge-primary px-3 py-2">
                        <a href="#" class="badge badge-pill badge-white small text-gray-light" @click.prevent="removeTag( tag )">
                            <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                        </a>
                        <span class="h5 font-weight-normal text-gray m-0">
                            {{ tag.label }}
                        </span>
                    </div>
                </div>
            </template>
        </template>

        <template #hidden="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="hidden"
                    v-bind="{ autocompleteList, selected, dropdownShow, tags, removeTag }"
            >
            </slot>
            <div style="display:none;" ref="tags">
                <slot name="tags"></slot>
            </div>
        </template>
        <template #next="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="next"
                    v-bind="{ autocompleteList, selected, dropdownShow, tags, removeTag }"
            >
                <template v-if="tags.length" v-for="tag in tags">
                    <div class="d-inline-block my-2 mx-2">
                        <a href="#" class="h5 font-weight-light text-gray-light m-0" @click.prevent="removeTag(tag)">
                            <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                        </a>
                        <span class="h6 font-weight-light text-gray m-0">
                            &nbsp;{{ tag.label }}
                        </span>
                    </div>
                </template>
            </slot>
        </template>
        <template #prev="{ autocompleteList, selected, dropdownShow }">
            <slot
                    name="prev"
                    v-bind="{ autocompleteList, selected, dropdownShow, tags, removeTag }"
            >
            </slot>
        </template>

    </input-autocomplete>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinAjax from './mixinAjax';
    import mixinInput from './mixinInput';

    import InputAutocomplete from './InputAutocomplete';

    const { props } = InputAutocomplete;

    export default {
        mixins: [ mixinCommon, mixinAjax, mixinInput ],

        components: {
            'input-autocomplete': InputAutocomplete
        },
        props: {
            ...props,

            hideTags: false,

            uniqueTagsBy: {
                type: String,
                default: ''
            },

            defaultTags: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            uniqueTags() {
                return !!this.uniqueTagsBy;
            },
            lastSelected() {
                return this.$refs.input.$data.selected;
            }
        },

        data() {
            return {
                tags: this.defaultTags,
                preventBlur: false
            };
        },
        mounted() {
            const tags = this.getJsonFromRef('tags');
            if( tags ) {
                this.tags = tags;
            }
        },
        methods: {
            onInputWrite( evt ) {
                switch( evt.which ) {
                    case 13 :
                        evt.preventDefault();
                        this.preventBlur = true;
                    break;
                }

            },
            onInputBlur( evt ) {
                if( this.preventBlur ) {
                    this.focus();
                    this.preventBlur = false;
                }

                setTimeout(() => this.inputValue = '', 0);

            },

            onAutocompleteSelect( item ) {
                const { text = '' } = item || {};
                const label = text.toLowerCase().trim();

                if( label ) {
                    this.addTag({
                        ...item,
                        label
                    });
                }

                this.inputValue = '';
            },

            addTag( tag ) {
                if( this.uniqueTags ) {
                    const fieldName = this.uniqueTagsBy;
                    for( let item of this.tags ) {
                        if( tag[fieldName] && item[fieldName] === tag[fieldName] ) {
                            return;
                        }
                    }
                }
                this.tags.push( tag );
            },
            removeTag( tagToRemove ) {
                this.tags = this.tags.filter(( tag ) => tag !== tagToRemove );
            },

            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( InputAutocomplete, overrideProps );
            }
        }
    };
</script>
